import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { servicedeskAtlassianAnalyticsResource } from '@atlassian/jira-router-resources-reports-atlassian-analytics/src/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskAtlassianAnalyticsRoute } from '@atlassian/jira-router-routes-servicedesk-reports-routes/src/servicedeskAtlassianAnalyticsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { AtlassianAnalytics, LazyAtlassianAnalytics } from './ui/atlassian-analytics/index.tsx';

export const servicedeskAtlassianAnalyticsRouteEntry = createEntry(
	servicedeskAtlassianAnalyticsRoute,
	() => ({
		group: 'servicedesk',
		component: AtlassianAnalytics,
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},
		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			servicedeskAtlassianAnalyticsResource,
			getConsolidationStateResource(),
		],
		forPaint: [LazyAtlassianNavigation, LazyAtlassianAnalytics],
		meta: {
			reporting: {
				id: APP_NAMES.ATLASSIAN_ANALYTICS,
				packageName: toPackageName(APP_NAMES.ATLASSIAN_ANALYTICS),
				teamName: 'ITSM Saga',
			},
		},
	}),
);
